import { FC, useEffect, useMemo, useState } from 'react'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import Separator from 'components/atoms/Separator/Separator'
import styles from 'components/features/creditCard/creditCardPanes/CardDetailsPane.styl'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { capitalizeFirstLetter, formatUSCurrency } from 'helpers/formatHelpers'
import { LabeledElement } from 'components/atoms/LabeledElement/LabeledElement'
import { CreditCardPanePreset } from 'components/features/creditCard/creditCardPanes/CreditCardPanePreset'
import { currentCardSelector, currentCCLedgerSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { ToggleCardLockActionButton } from 'components/features/pfm/Button/ActionButtons'
import Iframe from 'react-iframe'
import { CC_DETAILS_IFRAME_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import { sleep } from 'helpers/utilsHelpers'

const IFRAME_LOADING_TIME = 1000

const CardDetailsPane: FC<{}> = () => {
  const card = useStoreSelector(currentCardSelector)
  const ledger = useStoreSelector(currentCCLedgerSelector)
  const [timerIsExpired, setTimerIsExpired] = useState(false)

  useEffect(() => {
    async function toggleIsLoaded () {
      await sleep(IFRAME_LOADING_TIME)
      setTimerIsExpired(true)
    }
    toggleIsLoaded()
  })

  const cardLoader = useMemo(() => !timerIsExpired && (
    <div className={ styles.iframe }>
      <LoadingOverlay />
    </div>
  ), [timerIsExpired])

  if (!ledger || !card) {
    return <LoadingOverlay />
  }

  const { name_on_card, status } = card
  const { current_balance, credit_limit, available_credit, retail_apr, cash_apr } = ledger
  const cardIsLocked = status === 'suspended'

  return (
    <CreditCardPanePreset title='Card Details'>
      {/* <figure>
        <CardStatus
          status={ status }
          iconSlug={ cardIsLocked ? 'lock' : undefined }
        />
      </figure> */}
      { cardLoader }
      <Iframe
        url={ CC_DETAILS_IFRAME_URL + card.uid + '/widget/' }
        width='100%'
        height='100%'
        display={ timerIsExpired ? 'block' : 'none' }
        className={ styles.iframe }
      />
      <LabeledElement label='Name'             element={ name_on_card } />
      {/* <LabeledElement label='Card Number'      element={ formatMastercard(pan) } /> */}
      {/* <LabeledElement label='Expiration'       element={ moment(expiration).format(DATE_FORMAT_CARD_EXPIRATION) } /> */}
      {/* <LabeledElement label='Security Code'    element={ cvv } /> */}
      <LabeledElement label='Status'           element={ capitalizeFirstLetter(status) } />
      <Separator />
      <LabeledElement label='Credit Limit'     element={ formatUSCurrency(credit_limit, 'penny') } />
      <LabeledElement label='Current Balance'  element={ formatUSCurrency(current_balance, 'penny') } />
      <LabeledElement label='Available Credit' element={ formatUSCurrency(available_credit, 'penny') } />
      <LabeledElement label='Purchase APR'     element={ retail_apr + '%' } />
      <LabeledElement label='Cash Advance APR' element={ cash_apr + '%' } />
      <small>
        Does not include approved transactions that have not yet posted or
        payments that are pending or still processing.
      </small>
      { cardIsLocked && <ToggleCardLockActionButton text='Unlock Your Card' />}
    </CreditCardPanePreset>
  )
}
/* eslint no-multi-spaces: 0 */
export default CardDetailsPane
